import BaseMarketplaceModal, {
  Props as BaseMarketplaceModalProps,
} from "@/src/components/Modal/BaseMarketplaceModal";
import clsx from "clsx";
import { SiteWrapper } from "../grid/components/SiteWrapper";

import { MarketplaceModalHeader } from "./ModalHeader";

type Props = BaseMarketplaceModalProps & { title?: string };

const MarketplaceModal: React.FC<Props> = ({
  children,
  classes,
  isOpen,
  onClose,
  title,
}) => {
  return (
    <BaseMarketplaceModal
      isOpen={isOpen}
      onClose={onClose}
      classes={{ modal: clsx("md:w-[600px]", classes?.modal) }}
    >
      <SiteWrapper className={clsx("py-9")}>
        {title && (
          <MarketplaceModalHeader
            onClose={onClose}
            classes={{ outerDiv: "items-center" }}
          >
            {title}
          </MarketplaceModalHeader>
        )}
        {children}
      </SiteWrapper>
    </BaseMarketplaceModal>
  );
};

export default MarketplaceModal;
